import axios from 'axios'
import { getEnv } from 'src/env'

const AxiosInstance = axios.create({
  baseURL: getEnv('REACT_APP_SERVER_URL') + '/api',
  timeout: 35000,
  headers: {
    'Content-Type': 'application/json',
  },
})

AxiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('user')
  if (token) config.headers['Authorization'] = `Bearer ${token}`
  if (config.method == 'patch') config.headers['Content-Type'] = 'application/merge-patch+json'
  if (config.method == 'post') config.headers['Content-Type'] = 'application/json'
  return config
})

AxiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log(response);
    return response
  },
  function (error) {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:expired'))
    }
    if (error.response && error.code == 'ERR_NETWORK') {
      console.log(error)
      console.log(error.response)
    }
    return Promise.reject(error)
  },
)

export const isCancel = axios.isCancel;

export default AxiosInstance;